module.exports = __webpack_public_path__ + "img/logo-footer.520d1253.svg";